export const LOCAL_OFFERS_PAGE_SIZE = 20;
export const OFFERS_PAGE_SIZE = 16;
export const ELITE_OFFERS_PAGE_SIZE = 4;
export const SEARCH_DISTANCE_IN_KM = 12;
export const EXPLICIT_ELITE_OFFERS_PAGE_SIZE = 20;
